(function () {
  'use strict';

  const SIDEBAR_SELECTOR = '.productgrid--sidebar-menu';
  const PARENT_SELECTOR = '.navmenu-item-parent';
  const SUBMENU_SELECTOR = '.navmenu-submenu';
  const LINK_PARENT_SELECTOR = '.navmenu-link-parent';
  const CHEVRON_CLASS = 'custom-nav__chevron';
  const OPEN_CLASS = 'custom-nav--open';

  function buildChevron() {
    const btn = document.createElement('button');
    btn.className = CHEVRON_CLASS;
    btn.setAttribute('aria-label', 'Expand');
    btn.setAttribute('type', 'button');
    btn.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"
           fill="none" stroke="currentColor" stroke-width="2.5"
           stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <polyline points="6 9 12 15 18 9"></polyline>
      </svg>
    `;
    return btn;
  }

  function closeAll(sidebar) {
    sidebar.querySelectorAll(PARENT_SELECTOR).forEach(function (item) {
      item.classList.remove(OPEN_CLASS);
      const submenu = item.querySelector(':scope > ' + SUBMENU_SELECTOR);
      if (submenu) submenu.style.display = 'none';
      const chevron = item.querySelector(':scope > ' + '.' + CHEVRON_CLASS + ', :scope > * > .' + CHEVRON_CLASS);
      if (chevron) chevron.setAttribute('aria-expanded', 'false');
    });
  }

  function toggleItem(item) {
    const isOpen = item.classList.contains(OPEN_CLASS);
    const submenu = item.querySelector(':scope > ' + SUBMENU_SELECTOR);
    const chevron = item.querySelector('.' + CHEVRON_CLASS);

    if (isOpen) {
      item.classList.remove(OPEN_CLASS);
      if (submenu) submenu.style.display = 'none';
      if (chevron) chevron.setAttribute('aria-expanded', 'false');
    } else {
      item.classList.add(OPEN_CLASS);
      if (submenu) submenu.style.display = 'block';
      if (chevron) chevron.setAttribute('aria-expanded', 'true');
    }
  }

  function initSidebar(sidebar) {
    // Close all submenus on init
    sidebar.querySelectorAll(SUBMENU_SELECTOR).forEach(function (submenu) {
      submenu.style.display = 'none';
    });

    // Add chevron to each parent item
    sidebar.querySelectorAll(PARENT_SELECTOR).forEach(function (item) {
      const link = item.querySelector(':scope > ' + LINK_PARENT_SELECTOR);
      if (!link) return;

      const chevron = buildChevron();

      // Wrap link and chevron in a row
      const row = document.createElement('div');
      row.className = 'custom-nav__row';
      link.parentNode.insertBefore(row, link);
      row.appendChild(link);
      row.appendChild(chevron);

      // Toggle submenu on chevron click
      chevron.addEventListener('click', function (e) {
        e.stopPropagation();
        toggleItem(item);
      });
    });

    // Open the active path on page load
    const activeLink = sidebar.querySelector('.navmenu-link-active');
    if (activeLink) {
      let parent = activeLink.closest(PARENT_SELECTOR);
      while (parent) {
        const submenu = parent.querySelector(':scope > ' + SUBMENU_SELECTOR);
        const chevron = parent.querySelector('.' + CHEVRON_CLASS);
        parent.classList.add(OPEN_CLASS);
        if (submenu) submenu.style.display = 'block';
        if (chevron) chevron.setAttribute('aria-expanded', 'true');
        parent = parent.parentElement.closest(PARENT_SELECTOR);
      }
    }
  }

  /*
    * Google reviews 
    *
    * The GroPulse Google Reviews badge widget doesn't match our desired layout
    * and can't be positioned where we want it, so we rebuild our own version
    * here from its ld+json data. The original widget is hidden via custom.css
    * but stays in the DOM — it's the data source (ld+json + Maps link) and
    * keeps the structured data (AggregateRating) intact for SEO.
  */
  function initGoogleReviewSummary() {
    const target = document.querySelector('.utility-bar__content-right');
    if (!target) return;
    if (target.querySelector('.gr-summary')) return; // avoid adding it twice

    // 1. Find the review widget's ld+json
    let data = null;
    const scripts = document.querySelectorAll('script[type="application/ld+json"]');
    for (let i = 0; i < scripts.length; i++) {
      try {
        const parsed = JSON.parse(scripts[i].textContent);
        if (parsed && parsed.aggregateRating) { data = parsed; break; }
      } catch (e) { /* skip invalid JSON */ }
    }
    if (!data) return;

    // 2. Read the values
    const name = data.name || '';
    const ratingValue = data.aggregateRating.ratingValue;
    const reviewCount = data.aggregateRating.reviewCount;

    // 3. Get the Google Maps link from the badge (fallback: search by name)
    const linkEl = document.querySelector('.ht-badge-container a[href*="google.com/maps"]');
    const mapsLink = linkEl
      ? linkEl.getAttribute('href')
      : 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(name);

    // 4. Fill percentage: always show 5 stars, overlay a gold fill equal to the rating
    const fillPercent = (Math.max(0, Math.min(5, Number(ratingValue))) / 5) * 100;

    // 5. Build the HTML and insert it as a sibling right before content-right
    const el = document.createElement('a');
    el.className = 'gr-summary';
    el.href = mapsLink;
    el.target = '_blank';
    el.title = 'View our reviews';
    el.rel = 'noopener noreferrer';
    el.innerHTML =
      // '<span class="gr-summary__name">' + name + '</span>' +
      '<span class="gr-summary__stars" role="img" aria-label="' + ratingValue + ' out of 5 stars">' +
        '<span class="gr-summary__stars-bg">★★★★★</span>' +
        '<span class="gr-summary__stars-fill" style="width:' + fillPercent + '%">★★★★★</span>' +
      '</span>' +
      '<span class="gr-summary__value">' + ratingValue + '/5</span>' +
      '<span class="gr-summary__count">(' + reviewCount + ' Google reviews)</span>';

    target.prepend(el);
  }

  function init() {
    const sidebars = document.querySelectorAll(SIDEBAR_SELECTOR);
    if (sidebars.length) {
      sidebars.forEach(initSidebar);
    }

    initGoogleReviewSummary();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();